import {
  useContext
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  AppContext
} from '../context';

import {
  AAPromptStates,
  CacheKeys,
  FeatureToggles,
  OriginContexts,
  UserTypes
} from '../constants';

import {
  getStorageWithExpiry,
  setStorageWithExpiry
} from './storage-with-expiry';

import {
 isFeatureEnabled
} from './config-helper';

import {
 isEqual
} from './utils';

export const useRedirectHandler = () => {

  const history = useHistory();
  const {
    promptState,
    setPromptState,
    config,
    showAirtimeAdvancePrompt,
    setAppState
  } = useContext(AppContext);

  const clearBundleBalances =  () => {
    setAppState(prevState => ({
      ...prevState,
      bundleBalances: null
    }));
  };

  return (returnUrl, url, isZeroRated, forceRedirect) => {

    const userType = getStorageWithExpiry('msisdn', 'msisdnType', 'PREPAID');
    const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value');

    if (
      forceRedirect
      || !showAirtimeAdvancePrompt
      || isZeroRated
      || isEqual(userType, UserTypes.Contract)
      || !isFeatureEnabled(config, FeatureToggles.EnableRedirectHandler)
      || promptState === AAPromptStates.Finished
    ) {

      setPromptState(AAPromptStates.Idle);
      JourneyProvider.set('Prompt', { url: '' });
      JourneyProvider.set('Prompt', { returnUrl: '' });

      if (!isEqual(context, OriginContexts.VodaPay)) {

        window.open(url);
        history.replace(returnUrl);
        clearBundleBalances();

        return;
      }

      history.push(url);
      clearBundleBalances();

      return;
    }

    setStorageWithExpiry('Prompt', 'returnUrl', returnUrl);

    history.replace({
      pathname: '/handle-redirect',
      state: {
        url,
        isZeroRated
      }
    });
  };
};
